<template>
  <transition name="bounce-fade">
    <div class="adt_modal-outer adt-confirm-modal" v-show="isOpen">
      <div class="adt_modal" :class="classProp">
        <div class="adt_modal-close" @click="toggle">
          <i class="fas fa-times fa-lg"></i>
        </div>
        <div class="adt_modal-header mt-3">
          <h3 class="adt_heading-4" v-if="title">{{title}}</h3>
        </div>
        <div class="adt_modal-content">
          <slot name="content"></slot>
        </div>
        <div class="adt_modal-footer">
          <div v-for="(propButton, index) in buttons" :key="index">
            <button
              class="adt-confirm-btn"
              :style="{color: propButton.color}"
              @click="!propButton.loading ? propButton.callback() : ''"
              :disabled="propButton.disable"
            >
              <i v-if="propButton.loading" class="fas fa-spinner" />
              <span v-else>{{propButton.title}}</span>
            </button>
          </div>
        </div>        
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "AdtModalConfirm",
  data() {
    return {
      isOpen: false
    };
  },
  props: ["title", "classProp", "buttons"],
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    }
  },
  watch: {
    isOpen: function(val) {
      if (!val) {
        this.$emit("on-close");
      }
    }
  }
};
</script>
<style lang="scss">
.adt_modal-content {
  padding: 15px 25px;
}
.bounce-fade-enter-active {
  transition: opacity 1s;
  > * {
    animation: bounce-in 0.5s;
  }
}
.bounce-fade-leave-active {
  opacity: 0;
  > * {
    animation: bounce-in 0.5s reverse;
  }
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

i.fa-spinner {
  animation: rotating 2s linear infinite;
}

.adt_modal-outer.adt-confirm-modal {
  .adt_modal {
    padding: 0;
    border-radius: 10px;
    .adt_modal-header {
      margin-bottom: 0;
    }
    .adt-modal-delete p {
      text-align: center;
      padding: 5px;
      font-weight: 700;
    }

    .adt_heading-4 {
      padding: 10px;
      text-align: center;
      padding-top: 35px;
    }

    button.adt-confirm-btn {
      border: none;
      width: 100%;
      outline: none !important;
      padding: 10px;
      font-size: 16px;
      background: #fff;
      font-weight: 600;
      border-top: 1px solid #e4e4e4;
      &:hover {
        background: #f2f2f2;
      }
    }

    .adt_modal-footer {
      div {
        &:first-child {
          button.adt-confirm-btn {
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 0;
          }
        }
        &:last-child {
          button.adt-confirm-btn {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 10px;
          }
        }
      }
    }
  }
}
</style>

